function prettifyNumbers(number) {
  return number !== undefined
    ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    : '';
}

export { prettifyNumbers };
